(() => {
function init(scope=document){
 scope.querySelectorAll('[data-cz-inline-zoom]').forEach(button=>{
 if(button.dataset.ready)return;button.dataset.ready='true';
 const image=button.querySelector('img');let active=false,x=50,y=50,start,dragged=false;
 const clamp=v=>Math.max(0,Math.min(100,v));
 const position=(a,b)=>{x=clamp(a);y=clamp(b);image.style.transformOrigin=`${x}% ${y}%`;};
 function reset(){active=false;button.classList.remove('is-zoomed');button.setAttribute('aria-pressed','false');button.setAttribute('aria-label',button.dataset.zoomLabel);}
 button.addEventListener('click',event=>{
  if(dragged){dragged=false;return;}
  if(active){reset();return;}
  const rect=button.getBoundingClientRect();position(event.detail===0?50:(event.clientX-rect.left)/rect.width*100,event.detail===0?50:(event.clientY-rect.top)/rect.height*100);
  if(!button.dataset.fullLoaded){image.removeAttribute('srcset');image.src=button.dataset.zoomSrc;button.dataset.fullLoaded='true';}
  active=true;button.classList.add('is-zoomed');button.setAttribute('aria-pressed','true');button.setAttribute('aria-label',button.dataset.resetLabel);
 });
 button.addEventListener('pointerdown',event=>{dragged=false;if(!active||event.pointerType==='mouse')return;start={id:event.pointerId,cx:event.clientX,cy:event.clientY,x,y};button.setPointerCapture(event.pointerId);});
 button.addEventListener('pointermove',event=>{
  if(!active)return;const rect=button.getBoundingClientRect();
  if(event.pointerType==='mouse'){position((event.clientX-rect.left)/rect.width*100,(event.clientY-rect.top)/rect.height*100);return;}
  if(!start||event.pointerId!==start.id)return;
  const dx=event.clientX-start.cx,dy=event.clientY-start.cy;
  if(Math.abs(dx)+Math.abs(dy)>8)dragged=true;
  position(start.x-dx/rect.width*100,start.y-dy/rect.height*100);
 });
 button.addEventListener('pointerup',()=>{start=undefined;});button.addEventListener('pointercancel',()=>{start=undefined;dragged=false;});
 button.addEventListener('keydown',event=>{if(event.key==='Escape'){reset();return;}if(!active)return;const directions={ArrowLeft:[-8,0],ArrowRight:[8,0],ArrowUp:[0,-8],ArrowDown:[0,8]};if(directions[event.key]){event.preventDefault();const [a,b]=directions[event.key];position(x+a,y+b);}});
 const product=button.closest('[data-product]');product.addEventListener('change',reset);product.addEventListener('click',event=>{if(event.target.closest('[data-media-target]'))reset();});
 });
}
init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
